import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-community';
import * as moment from 'moment';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-set-approval-request',
  templateUrl: './set-approval-request.component.html',
  styleUrls: ['./set-approval-request.component.css']
})
export class SetApprovalRequestComponent implements OnInit {
  private gridApi: GridApi;
  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  SettlementcolumnDefs = [
    {headerName: 'Customer Name', field: 'Customer_Name', resizable: true, sortable: true,selectedNodes:true, filter: true,checkboxSelection: true,headerCheckboxSelection: true,},
    {headerName: 'Bank Name', field: 'bank_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Portfolio Name', field: 'portfolio_type', resizable: true, sortable: true, filter: true},
    {headerName: 'Settlement Type', field: 'settlement_type', resizable: true, sortable: true, filter: true},
    {headerName: 'Current Total', field: 'current_total', resizable: true, sortable: true, filter: true},
    {headerName: 'Payment Date', field: 'payment_date', resizable: true, sortable: true, filter: true},
    {headerName: 'Amount', field: 'amount', resizable: true, sortable: true, filter: true},
    {headerName: 'No of Installment', field: 'no_of_installments', resizable: true, sortable: true, filter: true},
    {headerName: 'First Installment', field: 'fst_installment', resizable: true, sortable: true, filter: true},
    {headerName: 'Approval Status', field: 'approval_status', resizable: true, sortable: true, filter: true},
    {headerName: 'Details', field: 'details_notes', resizable: true, sortable: true, filter: true},
    {headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true},
    {headerName: 'Created By', field: 'createdby', resizable: true, sortable: true, filter: true},
    {headerName: 'Creator Name', field: 'creator_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true},
    {headerName: 'ID', field: '_id', width: 250,resizable: true, sortable: true, filter: true},
    {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Account ID', field: 'account_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Passport Number', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
    {headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
  ];
  
  SettlementForm: UntypedFormGroup;
  areaCodeList: any;
  bankCodeList: any;
  fieldvisitCodeList: any;
  mStatusList: any;
  sStatusList: any;
  SettlementList = [];
  login_Details: any;
  TracingToolsList: any;
  actionstakenList: any;
  showOTSFS: boolean;
  uploaded: boolean;
  addmode: boolean;
  editmode: boolean;
  gridColumnApi: any;
  createdId: any;
  selectedId: void;
  fintId: any;
  customer_name: any;
  portfolio_type: any;
  bank_name: any;
  FV_Remarks: any;
  FV_Done_Date: any;
  FV_Feedback: any;
  Fv_Feedback: any;
  portfolio_id: any;
  passport_no: string;
  customer_id: any;
  acc_no: any;
  bank_id: any;
  product_id: any;
  finterstal_id: any;
  client_id: any;
  porfolio_id: any;
  bucket_id: any;
  nationality: any;
  cycle: any;
  flow_status: any;
  product_name: any;
  bank_allocation: any;
  bucket: any;
  assigned_by: any;
  assigned_to: any;
  date_of_assign: any;
  touch_status: any;
  agreement_id: any;
  allocated_to: any;
  allocations_status: any;
  cif: any;
  customer_details: any;
  Customer_Name: any;
  date_of_allocations: any;
  total_out_standing: any;
  update_check: any;
  _id: any;
  settlement_type: any;
  account_id: any;
  current_total: any;
  payment_date: any;
  amount: any;
  attachment_url: any;
  no_of_installments: any;
  fst_installment: any;
  approval_status: any;
  reportingto_id: any;
  details_notes: any;
  createdby: any;
  creator_name: any;
  constructor(private formBuilder:UntypedFormBuilder, private _api:ApiService, @Inject(SESSION_STORAGE) private storage: StorageService,) { 
    this.SettlementForm = this.formBuilder.group({
      _id:['',Validators.required],
      settlement_type:['',Validators.required],
      account_id:[''],
      current_total:['',Validators.required],
      payment_date:['',Validators.required],
      amount:['',Validators.required],
      attachment_url:[''],
      no_of_installments:[''],
      fst_installment:[''],
      approval_status:['',Validators.required],
      reportingto_id :['',Validators.required],
      details_notes:['',Validators.required],
      createdby:[''],
      creator_name:[''],
      customer_id:[''],
      client_id :[''],
      bank_id :[''],
      product_id :[''],
      portfolio_id :[''],
      bucket_id :[''],
      finterstal_id :[''],
      passport_no :[''],
    })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onGetSelectedRowId() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0) {
      const selectedData = selectedNodes[0].data;
      this.createdId = selectedData.createdby;
      this.fintId = selectedData.finterstal_id;
      this.customer_name = selectedData.Customer_Name;
      this.portfolio_type = selectedData.portfolio_type;
      this.bank_name = selectedData.bank_name;
      this.Fv_Feedback = selectedData.FV_Feedback;
      this.passport_no = selectedData.passport_no;
      this.customer_id = selectedData.customer_id;
      this.portfolio_id = selectedData.portfolio_id;
      this.acc_no = selectedData.customer_name.acc_no;
      this.bank_id = selectedData.bank_id;
      this.product_id = selectedData.product_id;
      this.finterstal_id = selectedData.finterstal_id;
      this.client_id = selectedData.client_id;
      this.porfolio_id = selectedData.porfolio_id;
      this.bucket_id = selectedData.bucket_id;
    
      this.nationality = selectedData.nationality;
      this.cycle = selectedData.cycle;
      this.flow_status = selectedData.flow_status;
    
      this.product_name = selectedData.product_name;
      this.bank_allocation = selectedData.bank_allocation;
      this.bucket = selectedData.bucket;
    
    
      this.assigned_by = selectedData.assigned_by;
      this.assigned_to = selectedData.assigned_to;
      this.date_of_assign = selectedData.date_of_assign;
      this.touch_status= selectedData.touch_status;
      this.agreement_id = selectedData.agreement_id;
      this.allocated_to = selectedData.allocated_to;
      this.allocations_status= selectedData.allocations_status;
      this.cif = selectedData.cif;
      this.customer_details = selectedData.customer_details;
      this.Customer_Name = selectedData.Customer_Name;
      this.date_of_allocations = selectedData.date_of_allocations;
      this.total_out_standing = selectedData.total_out_standing;
      this.update_check = selectedData.update_check;
      this._id = selectedData[0]._id;
      this.settlement_type = selectedData[0].settlement_type;
      this.account_id = selectedData[0].account_id;
      this.current_total = selectedData[0].current_total;
      this.payment_date = selectedData[0].payment_date;
      this.amount = selectedData[0].amount;
      this.attachment_url = selectedData[0].attachment_url;
      this.no_of_installments = selectedData[0].no_of_installments;
      this.fst_installment = selectedData[0].fst_installment;
      this.approval_status = selectedData[0].approval_status;
      this.reportingto_id = selectedData[0].reportingto_id;
      this.details_notes = selectedData[0].details_notes;
      this.createdby = selectedData[0].createdby;
      this.creator_name = selectedData[0].creator_name;
     

      console.log('createdId row ID:', this.settlement_type);
    }
  }

  ngOnInit(): void {
    this.addmode = true;
    this.editmode = false;
    this._api.getlist_area_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.areaCodeList = data['Data'];
      } else {
        this.areaCodeList = [];
      }
    });
    this._api.getlist_bank_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.bankCodeList = data['Data'];
      } else {
        this.bankCodeList = [];
      }
    });
    this._api.getlist_fieldvisit_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.fieldvisitCodeList = data['Data'];
      } else {
        this.fieldvisitCodeList = [];
      }
    });
    this._api.getlist_mainStatus_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.mStatusList = data['Data'];
      } else {
        this.mStatusList = [];
      }
    });

    this._api.getlist_subStatus_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.sStatusList = data['Data'];
      } else {
        this.sStatusList = [];
      }
    });

    this._api.getlist_tracingtools().subscribe(data=>{
      if (data['Code'] == 200) {
        this.TracingToolsList = data['Data'];
      } else {
        this.TracingToolsList = [];
      }
    });

    this._api.getlist_actionstaken().subscribe(data=>{
      if (data['Code'] == 200) {
        this.actionstakenList = data['Data'];
      } else {
        this.actionstakenList = [];
      }
    });

    this.login_Details = this.getFromLocal("login_Details");

    // this.SettlementForm.patchValue({
    //   createdby: this.login_Details.email_id,
    //   creator_name: this.login_Details.name,
    //   customer_id: localStorage.getItem("Customer_ID"),
    //   account_id:localStorage.getItem("Customer_ID")
    // });
    const data = {
      user_id:this.login_Details._id
    }
    this._api.getlist_sem_approval_request(data).subscribe(data=>{
      if (data['Code']==200) {
        this.SettlementList = data['Data'];
        this.SettlementList.forEach(element => {
          let name = JSON.parse(element.customer_name.customer_details[0],);
          element.agent_name = name[0].AGENT;
          element.Customer_Name = name[0].Customer_Name;
        });
        console.log(this.SettlementList,"1245");
        
      } else {
        this.SettlementList = null;
      }
    });
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  getFile(event){
    this.uploaded = false;
    const File = event.target.files[0];
    console.log(File);
    this._api.uploadFile(File).subscribe(data=>{
      if (data['Code'] = 200) {
        this.SettlementForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = true;
      } else {
        this.SettlementForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = false;
      }
    })
  }

  editapprovalRequest(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length == 1) {
      this.addmode = false;
      this.editmode = true;
      this.SettlementForm.patchValue({
        _id:selectedData[0]._id,
        settlement_type:selectedData[0].settlement_type,
        account_id:selectedData[0].account_id,
        current_total:selectedData[0].current_total,
        payment_date:selectedData[0].payment_date,
        amount:selectedData[0].amount,
        attachment_url:selectedData[0].attachment_url,
        no_of_installments:selectedData[0].no_of_installments,
        fst_installment:selectedData[0].fst_installment,
        approval_status:selectedData[0].approval_status,
        reportingto_id:selectedData[0].reportingto_id,
        details_notes:selectedData[0].details_notes,
        createdby:selectedData[0].createdby,
        creator_name:selectedData[0].creator_name,
        customer_id:selectedData[0].customer_id,
        client_id :selectedData[0].client_id,
        bank_id :selectedData[0].bank_id,
        product_id :selectedData[0].product_id,
        portfolio_id :selectedData[0].portfolio_id,
        bucket_id :selectedData[0].bucket_id,
        finterstal_id :selectedData[0].finterstal_id,
        passport_no :selectedData[0].passport_no,
      });
    } else if (selectedData.length > 1) {
      alert("Select Only one Record");
    } else {
      alert("Select atleast one Record");
    }
    
  }

  addNewSettlement(){
    
    if (this.SettlementForm.valid) {
      this._api.update_new_settlement(this.SettlementForm.value).subscribe(data=>{
        if (data['Code'] == 200) {
          this.onPagereload();
          
          this.sendNotification(this.SettlementForm.value);
          alert(data['Message']);
        } else {
          alert(data['Message']);
        }
      });
    } else {
      console.log(this.SettlementForm.value);
      
      alert('Form No Valid');
    }
  }


  sendNotification(_data){
    const dataFormat = {
      from: this.login_Details._id ,
      to: this.createdId,
      title: "New Notification",
      content: "You have recieved a settlement Updated",
      FintId: this.fintId,
      Bank_Name: this.bank_name,
      Portfolio_Name: this.portfolio_type,
      Customer_Name:this.customer_name,
      FV_Feedback: this.Fv_Feedback,
      passport_no : this.passport_no,
      customer_id : this.customer_id,
      portfolio_id : this.portfolio_id,
      acc_no : this.acc_no,
      bank_id : this.bank_id,
      product_id : this.product_id,
      finterstal_id : this.finterstal_id,
      link : '/admin_panel/user/createuser?_id='+this.customer_id,
      read : false,
      status: true,
      view :false      
    }
    console.log("dataFormat",dataFormat);
    
    this._api.create_notifications(dataFormat).subscribe(data=>{
      if (data['Code'] == 200) {
        console.log("Sent",data);
      } else {
        console.log("Failed");
      }
    });

  }
  onPagereload(){
    const data = {
      user_id:this.login_Details._id
    }
      this._api.getlist_sem_approval_request(data).subscribe(data=>{
        if (data['Code']==200) {
          this.SettlementList = data['Data'];
          this.SettlementList.forEach(element => {
            let name = JSON.parse(element.customer_name.customer_details[0],);
            element.agent_name = name[0].AGENT;
            element.Customer_Name = name[0].Customer_Name;
          });
          console.log("this.SettlementList1",this.SettlementList);
          
        } else {
          this.SettlementList = null;
        }
      });
  }

  cancel(){
    this.addmode = true;
    this.editmode = false;
    this.SettlementForm.reset();
  }

  getSettlementType(event){
    if (event.target.value == "MTS") {
      this.showOTSFS = true;
    } else {
      this.showOTSFS = false;
    }
  }
}
